import React from 'react';

export interface RuleCardContextProps {
  open: boolean;
}

export const RuleCardContext = React.createContext<RuleCardContextProps>({
  open: false,
});
